/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Item_2_TitleInputs */

const es_home_usecases_item_2_title = /** @type {(inputs: Home_Usecases_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperación de Contexto de Emails`)
};

const en_home_usecases_item_2_title = /** @type {(inputs: Home_Usecases_Item_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Context Recovery`)
};

/**
* | output |
* | --- |
* | "Email Context Recovery" |
*
* @param {Home_Usecases_Item_2_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_item_2_title = /** @type {((inputs?: Home_Usecases_Item_2_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Item_2_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_item_2_title(inputs)
	return en_home_usecases_item_2_title(inputs)
});
export { home_usecases_item_2_title as "home.usecases.item_2_title" }